import APITemplate from '@/api/APITemplate'

const url = '/api/fines'

const template = APITemplate(url)
export default {
  ...template
}
